import { StateService } from '@uirouter/angular';
import { Injectable } from '@angular/core';
import { GfTranslateService } from '../../../../services/core.translate.service';

import * as _ from 'lodash-es';

@Injectable()
export class SystemLogReportHelper {

    constructor(
        private gfTranslateService: GfTranslateService,
        private stateService: StateService,
    ) { }

    getSortFields() {
        return {
            'logDate': this.gfTranslateService.translate('Date'),
            'projectId': this.gfTranslateService.translate('Project'),
            'source': this.gfTranslateService.translate('Source'),
            'param1': this.gfTranslateService.translate('Param1'),
            'param2': this.gfTranslateService.translate('Param2'),
            'param3': this.gfTranslateService.translate('Param3'),
            'userId': this.gfTranslateService.translate('User')
        };
    }

    getAnyFilterObj() {
        return { id: '', label: this.gfTranslateService.translate("Any"), defaultSelected: true };
    }

    getCustomFilterObj() {
        return { id: null, label: this.gfTranslateService.translate("Custom"), defaultSelected: false };
    }

    getDateRangeElements() {
        return [
            this.getAnyFilterObj(),
            { id: '-7 days', label: this.gfTranslateService.translate("This Week") },
            { id: '-15 days', label: this.gfTranslateService.translate("Last 15 days") },
            { id: '-30 days', label: this.gfTranslateService.translate("Last 30 days") },
            { id: '-60 days', label: this.gfTranslateService.translate("Last 60 days") },
            { id: '-90 days', label: this.gfTranslateService.translate("Last 90 days") },
            { id: '-365 days', label: this.gfTranslateService.translate("Last year") }
        ];
    }

    getSourceElements() {
        return [
            this.getAnyFilterObj(),
            { id: 'version-check', label: this.gfTranslateService.translate("Client Version Checks") },
            { id: 'maillog', label: this.gfTranslateService.translate("Email Log") }
        ];
    }

    getBaseFilters() {
        var any = this.getAnyFilterObj();

        var ret = [
            { alias: "s", fieldName: this.gfTranslateService.translate("Source"), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getSourceElements() },
            { alias: "u", fieldName: this.gfTranslateService.translate("User"), value: '', fieldType: 4, isExtraField: false },
            { alias: "p", fieldName: this.gfTranslateService.translate("Project"), value: '', fieldType: 4, isExtraField: false },
            { alias: "p1", fieldName: this.gfTranslateService.translate("Param 1"), value: '', fieldType: 4, isExtraField: false },
            { alias: "p2", fieldName: this.gfTranslateService.translate("Param 2"), value: '', fieldType: 4, isExtraField: false },
            { alias: "p3", fieldName: this.gfTranslateService.translate("Param 3"), value: '', fieldType: 4, isExtraField: false },
            { alias: "r", fieldName: this.gfTranslateService.translate("Date Range"), value: any, fieldType: 1, isExtraField: false, fieldElements: this.getDateRangeElements() },
            { alias: "st", fieldName: this.gfTranslateService.translate("Start Date"), value: '', fieldType: 9, isExtraField: false },
            { alias: "end", fieldName: this.gfTranslateService.translate("End Date"), value: '', fieldType: 9, isExtraField: false }
        ];
        return ret;
    }

    getSelectedElement(filter, stateParams) {
        var val = _.get(stateParams, filter.alias, false) || '';
        var elem = _.find(filter.fieldElements, { id: val });
        if (!elem) {
            elem = _.find(filter.fieldElements, { defaultSelected: true });
        }
        return elem;
    }

    setFiltersFromStateParams(filters) {
        return _.map(
            filters,
            (f) => {
                switch (f.fieldType) {
                    case 1: // list
                        f.value = this.getSelectedElement(f, this.stateService.params);
                        break;

                    default: // text/other
                        f.value = _.get(this.stateService.params, f.alias, '');
                        break;
                }
                return f;
            }
        );
    }
}
